import { render } from "./ModalVotacionGala.vue?vue&type=template&id=f67aa4fa&scoped=true"
import script from "./ModalVotacionGala.vue?vue&type=script&lang=js"
export * from "./ModalVotacionGala.vue?vue&type=script&lang=js"

import "./ModalVotacionGala.vue?vue&type=style&index=0&id=f67aa4fa&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f67aa4fa"]])

export default __exports__